<mat-card style="padding-top: 0; padding-left: 0px; padding-right: 10px;">
    <mat-card-header style="background: inherit;padding-left: 22px !important; padding-top: 5px !important;" >
        <mat-card-subtitle style="margin-left:0px;font-weight: 400;font-size: 14px;">Add one or more Connector Type. Configure each data connector, column mappings and Ingest
            transforms. Review and save
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div style="margin-bottom: 10px;margin-top: 6px;">
            <span style="margin-left: 8px; font-weight: bold;font-size: 14px;">Data Connector :</span>
            <mat-select [(value)]="viewModel.selectedIngestConfig" (selectionChange)="onIngestConfigChanged($event)"
                placeholder="Add new Ingest Farm" style="margin-left: 12px; margin-right: 10px; width: 200px">
                <mat-option *ngFor="let ingestConfig of viewModel.dataTransformConfigViewModel.ingestConfigs"
                    [value]="ingestConfig">{{ingestConfig.name}}</mat-option>
            </mat-select>

            <button mat-flat-button class="big-icon-btn" title="Add new Ingest Farm" (click)="onAddNewIngestFarm()" [disabled]="isReadOnly" style="  background: #000 !important;">
                <mat-icon color="primary">add_circle</mat-icon>
                <span class="btn-text"> Add</span>
            </button>
            <button mat-flat-button class="big-icon-btn" title="Edit Ingest Farm" (click)="onEditIngestFarm(viewModel.selectedIngestConfig)"
                [disabled]="!viewModel.selectedIngestConfig || isReadOnly" style="margin-left: 10px;background: #000 !important;">
                <mat-icon style="color: #9e9e9e;">edit</mat-icon>
                <span class="btn-text"> Rename</span>
            </button>
            <button mat-flat-button class="big-icon-btn" title="Delete Ingest Farm"
                (click)="onDeleteIngestFarm(viewModel.selectedIngestConfig)"
                [disabled]="!viewModel.selectedIngestConfig || isReadOnly" style="margin-left: 10px;background: #000 !important;">
                <mat-icon class="red-icon">delete_forever</mat-icon>
                <span class="btn-text">Delete</span>
            </button>
        </div>
        <div style="border-top: solid 1px #7c7c7c; height: 1px;margin-bottom: 15px;"></div>
        <div class="empty-content" *ngIf="!viewModel.selectedIngestConfig">
            No Ingest Farms exist
        </div>
        <div style="margin-top: -10px;">
        <mat-accordion #stepperVertical *ngIf="viewModel.selectedIngestConfig" style="margin: 0px" multi>
            <mat-expansion-panel (opened)="onPanelOpened('connector')" expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ viewModel.steps[0].name }} </mat-panel-title>
                </mat-expansion-panel-header>
                <app-import-data #dataConnector [ingestConfigViewModel]="viewModel.selectedIngestConfig"
                    [viewModel]="viewModel.dataTransformConfigViewModel" [stepModel]="viewModel.steps[0]"
                    (stateChanged)="onDataConnectorStateChanged($event)"></app-import-data>
            </mat-expansion-panel>

            <mat-expansion-panel class="selected-step-ingest" #mapperStep (opened)="onPanelOpened('mapper', true, false)">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{viewModel.steps[1].name}} </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- <button mat-raised-button color="primary" (click)="loadConnectorColumns()">
                    Load Columns
                  </button> -->
                  <div style="margin-bottom: 3px;margin-top: 3px;">
                <button mat-raised-button color="primary" style="margin-left: 4px;" (click)="runAutoMapper()" [disabled]="isReadOnly" class="blue-action-btn" >
                    Run Auto Mapper
                  </button>
                  <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="mapSelector()" [disabled]="isReadOnly" class="blue-action-btn">
                    Map Library
                  </button>
                  <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="clearMap()" [disabled]="isReadOnly" class="blue-action-btn">
                    Clear Map
                  </button>
                   <button mat-button class="export-hover-btn" (click)="onClickExportOutput()" style="color: #1ea9d3;margin-left: 5px;height: 32px;display: inline-flex; align-items: center;vertical-align: middle;flex-direction: row;gap: 3px; white-space: nowrap;line-height: 1;"
                    >
                    <img
                    src="../assets/images/exporticon.png" style="width: auto;display: inline-block;vertical-align: middle;object-fit: contain;"
                    />
                    <span>EXPORT</span>
                    </button>
                  </div>
                <!-- <div class="center" *ngIf="viewModel.isLoadingColumns">
                    <mat-progress-spinner diameter="32" mode="indeterminate" color="primary"
                        style="margin-right: 10px;"></mat-progress-spinner> Loading columns from Data Connector...
                </div> -->
                <div class="loading-overlay" *ngIf="viewModel.isLoadingColumns">
                    <mat-progress-spinner
                    diameter="50"
                    mode="indeterminate"
                    color="primary">
                    </mat-progress-spinner>
                    <div class="loading-text">Loading columns from Data Connector...</div>
                </div>
                <div class="center" *ngIf="viewModel.loadColumnsFailed">
                    <span style="font-size: 16px;">{{viewModel.lastErrorMessage}}</span>
                    <button mat-flat-button (click)="loadColumns()">Retry</button>
                </div>
                <div style="margin-left: 2px;">
                    <app-mapper-flow-layout *ngIf="!viewModel.loadColumnsFailed" #mapperLayout
                        (targetColumnChanged)="onMapperTargetColumnChanged($event)"
                        [stepModel]="viewModel.steps[1]"
                        [dataTransformConfigViewModel]="viewModel.dataTransformConfigViewModel"
                        [ingestConfig]="viewModel.selectedIngestConfig"></app-mapper-flow-layout>
                </div>
                <!--Add Placeholder Column Button-->
                <div style="margin-left: -6px;">
                    <button mat-button (click)="addPlaceholderFields()" [disabled]="isReadOnly" class="placeholder-btn">
                        <div class="center-container align-left">
                            <mat-icon color="primary">add_circle</mat-icon>
                            <span>Add Placeholder Column</span>
                        </div>
                    </button>   
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel (opened)="onPanelOpened('preview')">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ viewModel.steps[2].name }} </mat-panel-title>
                </mat-expansion-panel-header>
                <button mat-raised-button color="primary" style="margin-left: 4px;margin-top: 3px;" (click)="refreshPreview()" class="blue-action-btn">
                    Refresh Preview
                  </button>
                 <div style="position: relative">
                    <!-- <div *ngIf="previewTable.dataSource" style="position: absolute; width: 100%;">
                        <mat-form-field style="width: 60%;" appearance="outline">
                            <mat-label>Sort By</mat-label>
                            <mat-chip-listbox style="width: 100%" #chipList aria-label="Sort By">
                                <mat-chip *ngFor="let sortInfo of viewModel.sortInfo"
                                    (removed)="removeSortInfo(sortInfo)">
                                    {{sortInfo.sortField}}
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_down
                                    </mat-icon>
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_up
                                    </mat-icon>
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <input style="width: 100%; cursor: pointer;" [readonly]="true"
                                    (click)="showSortBuilder()" matInput placeholder="Edit Sort..." #sortInfoInput
                                     [formControl]="sortCtrl" [matChipInputFor]="chipList"> 
                            </mat-chip-listbox>
                        </mat-form-field>
                    </div> -->
                    <!-- <app-preview-table [hideRefresh]="true" [delegate]="this" #previewTable [hideOptions]="true"
                        [viewModel]="previewDataViewModel"></app-preview-table> -->
                </div> 
                <div style="margin-left: 5px;">
                <mat-tab-group animationDuration="300ms" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabClick($event)">
                    <mat-tab label="Raw Data ({{rawDataColumnsCount}})">
                        <div style="position: relative;">
                            <app-preview-table [delegate]="this" #rawDataFarmPreviewTable [hideRefresh]="true"
                                [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="ingestRaw" previewTypeName="Raw"></app-preview-table>
                        </div>
                    </mat-tab>
                    <mat-tab label="Input ({{inputDataColumnsCount}})">
                        <div style="position: relative;">
                            <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="ingestInput" previewTypeName="Input"></app-preview-table>
                        </div>
                    </mat-tab>
                    <mat-tab label="Output ({{outputDataColumnsCount}})">
                        <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="ingestOutput" previewTypeName="Output"></app-preview-table>
                    </mat-tab>
                </mat-tab-group>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel (opened)="onPanelOpened('ingesttransform')">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{ viewModel.steps[3].name }} </mat-panel-title>
                </mat-expansion-panel-header>
                    <app-import-data-ingest [ingestTransformConfigViewModel]="viewModel.selectedIngestConfig"
                    [viewModel]="viewModel.dataTransformConfigViewModel" [stepModel]="viewModel.steps[0]"
                    [ingestConfig]="viewModel.selectedIngestConfig"
                    (stateChanged)="onDataConnectorStateChanged($event)"></app-import-data-ingest>
            </mat-expansion-panel>
        </mat-accordion>
        </div>
    </mat-card-content>
</mat-card>
